/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Dryer } from "./modelDryer";

class ControllerDryer extends ControllerModel {
  constructor() {
    super("ControllerDryer");

    this.setNewNode = (callback) => {
      let dryer = new Dryer();
      dryer.decorate(callback);

      this.addNode(dryer);
      SingletonFlowchart.SaveStatus();
    };

    this.loadNode = (node, callback) => {
      let dryer = new Dryer();
      dryer.copyFrom(node);
      dryer.decorate(callback);
      this.addNode(dryer);
    };

    this.getProperties = async (node) => {
      let n = new Dryer();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new Dryer();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerDryer };
